'use strict';

module.exports = {
    parent: 'parent',
    child: 'child',
    accept: 'accept',
};
